import React from 'react';
import phone from '../../../assets/images/call.svg'
import Image from '../../atoms/Image/Image';
const PhoneNo =()=>{
    return(
        <>
        <div className='contact-info'>
                <figure><Image src={phone} alt="Location" /></figure>
                <div>
                    <h3 className='h4'>Phone No</h3>
                    <p className='mb-0'><a href="tel:+918421555659" className='contact-email'>+91 8421555659</a></p>
                </div>
            </div>
        </>
    )
}
export default PhoneNo